export default "__VITE_ASSET__dce308ae__"